import React from 'react';
import { timeAgo, avInitials } from '../lib/utils';

const AV_GRADIENTS = {
  arshad:  'linear-gradient(135deg,#0EA5E9,#0369A1)',
  fahad:   'linear-gradient(135deg,#6366F1,#3730A3)',
  prateek: 'linear-gradient(135deg,#F59E0B,#B45309)',
  utkarsh: 'linear-gradient(135deg,#EC4899,#9D174D)',
  zeba:    'linear-gradient(135deg,#A855F7,#6B21A8)',
  azmath:  'linear-gradient(135deg,#10B981,#065F46)',
  'claude ai': 'linear-gradient(135deg,#0EA5E9,#6366F1)',
};

export default function ActivityPane({ open, activity, onClose }) {
  return (
    <aside style={{ ...styles.pane, transform: open ? 'translateX(0)' : 'translateX(100%)' }}>
      <div style={styles.head}>
        <h3 style={styles.title}>Activity</h3>
        <button onClick={onClose} style={styles.closeBtn}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" width="16" height="16">
            <path d="M18 6 6 18M6 6l12 12"/>
          </svg>
        </button>
      </div>
      <div style={styles.list}>
        {!activity.length ? (
          <div style={styles.empty}>No activity yet. Updates appear here as the team works.</div>
        ) : (
          [...activity].reverse().map((a, i) => (
            <div key={i} style={styles.item}>
              <span style={{ ...styles.av, background: AV_GRADIENTS[a.who?.toLowerCase()] || '#94A3B8' }}>
                {avInitials(a.who)}
              </span>
              <div style={styles.body}>
                <div><strong style={{ fontWeight:600 }}>{a.who}</strong>{' '}{a.action}</div>
                <div style={styles.time}>{timeAgo(a.at)}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </aside>
  );
}

const styles = {
  pane: { position:'fixed', right:0, top:0, bottom:0, width:380, background:'white', borderLeft:'1px solid #E4ECF4', transition:'transform .35s cubic-bezier(.4,0,.2,1)', zIndex:60, boxShadow:'-8px 0 32px -8px rgba(10,37,64,.1)', display:'flex', flexDirection:'column' },
  head: { padding:'18px 22px', borderBottom:'1px solid #E4ECF4', display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 },
  title: { fontFamily:"'Fraunces',serif", fontSize:18, fontWeight:500, letterSpacing:'-0.02em', margin:0 },
  closeBtn: { width:30, height:30, display:'grid', placeItems:'center', borderRadius:8, color:'#7A8BA3', background:'none', border:'none', cursor:'pointer' },
  list: { padding:'14px 22px', overflowY:'auto', flex:1 },
  empty: { padding:'24px 4px', color:'#7A8BA3', fontSize:13, textAlign:'center' },
  item: { display:'flex', gap:12, padding:'12px 0', borderBottom:'1px solid #EEF3F8', fontSize:12.5 },
  av: { width:24, height:24, borderRadius:'50%', flexShrink:0, display:'grid', placeItems:'center', color:'white', fontSize:10, fontWeight:600 },
  body: { color:'#3D5878', lineHeight:1.5 },
  time: { fontSize:10.5, color:'#7A8BA3', marginTop:3, fontFamily:"'JetBrains Mono',monospace" },
};
